// extracted by mini-css-extract-plugin
export default {"backdrop":"BulkDownloadModal-backdrop__a23250bb2e2cc3b16a74","modal":"BulkDownloadModal-modal__fcc4cb6f18e1c93abc1f"};